import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@devhop/ui";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <Card className="w-full gap-0 border-border bg-card shadow-sm">
      <CardHeader className="space-y-1 pb-4">
        <CardTitle className="font-medium text-card-foreground text-lg tracking-tight">
          ເຂົ້າລະບົບ
        </CardTitle>
        <CardDescription className="text-muted-foreground">
          ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານຂອງທ່ານເພື່ອເຂົ້າໃຊ້ບໍລິການພະນັກງານ
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <SignInForm />
      </CardContent>
    </Card>
  );
}
